
<div [ngClass]="[initialized ? 'shown' : 'hidden']" class="dash-card-back dash-big">
  <div *ngIf="!loaded" class="float-top-left-spinner">{{'Loading...'|locale}}</div>
  <div id="chart_equipment_levels" class="dash-chart"></div>
</div>